(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bba-cart-page-offers"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('bba-page-offers'))customElements.define('bba-page-offers',class extends HTMLElement{
 connectedCallback(){
  this.boundClick=e=>{const b=e.target.closest('[data-bba-cart-add]');if(b)this.add(b);};this.addEventListener('click',this.boundClick);
  const cards=Array.from(this.querySelectorAll('.bba-cart-upsell'));const settings=this.querySelector('.bba-cart-upsells');
  const limit=Math.min(4,Math.max(3,parseInt(settings?.dataset.displayLimit,10)||4));
  for(let i=cards.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[cards[i],cards[j]]=[cards[j],cards[i]];}
  cards.forEach((c,i)=>{c.hidden=i>=limit;c.style.order=i;});
  if(typeof subscribe==='function')this.unsub=subscribe(PUB_SUB_EVENTS.cartUpdate,e=>{if(e.source!=='bba-page-offers')this.refresh();});
 }
 disconnectedCallback(){this.removeEventListener('click',this.boundClick);this.unsub?.();this.controller?.abort();}
 async refresh(){
  this.controller?.abort();this.controller=new AbortController();
  try{const url=new URL(window.location.href);url.searchParams.set('section_id',this.dataset.section);const r=await fetch(url,{signal:this.controller.signal});if(!r.ok)return;const doc=new DOMParser().parseFromString(await r.text(),'text/html');const next=doc.querySelector('bba-page-offers');if(next)this.replaceWith(next);}catch(e){if(e.name!=='AbortError')console.warn(e);}
 }
 async add(button){
  if(this.busy)return;this.busy=true;button.disabled=true;button.closest('article')?.classList.add('is-adding');
  const error=this.querySelector('.bba-cart-upsells__error');if(error)error.hidden=true;
  const ids=[document.querySelector('#main-cart-items')?.dataset.id,document.querySelector('#main-cart-footer')?.dataset.id,this.dataset.section,'cart-icon-bubble','cart-drawer'].filter(Boolean);
  const opts=this.querySelector('.bba-cart-upsells').dataset;let added=false;
  const post=async(url,payload)=>{const response=await fetch(url,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({...payload,sections:ids,sections_url:window.location.pathname})});const data=await response.json();if(!response.ok||data.status)throw new Error(data.description||data.message||this.dataset.error);return data;};
  try{
   let state=await post(routes.cart_add_url,{items:[{id:Number(button.dataset.bbaCartAdd),quantity:1,properties:{_bba_special_offer:'Quantity offer'}}]});added=true;
   const response=await fetch(routes.cart_url+'.js',{headers:{Accept:'application/json'}});if(!response.ok)throw new Error(this.dataset.error);const cart=await response.json();
   const code=opts.discountCode?.trim();
   if(code){const codes=(cart.discount_codes||[]).map(x=>x.code).filter(Boolean);const desired=codes.filter(x=>x.toLowerCase()!==code.toLowerCase()&&x.toLowerCase()!=='bba-cart5');const count=cart.items.reduce((sum,x)=>Number(x.final_line_price)>0 && x.properties?._bba_free_gift!==true && x.properties?._bba_free_gift!=='true'?sum+Number(x.quantity||0):sum,0);if(codes.map(x=>x.toLowerCase()).sort().join(',')!==desired.map(x=>x.toLowerCase()).sort().join(','))state=await post(routes.cart_update_url,{discount:desired.join(',')});}
   for(const id of ids){const html=state.sections?.[id];if(!html)continue;const doc=new DOMParser().parseFromString(html,'text/html');if(id==='cart-icon-bubble'){const target=document.getElementById(id);if(target)target.innerHTML=doc.querySelector('.shopify-section')?.innerHTML||html;}else if(id==='cart-drawer'){const target=document.querySelector('cart-drawer');const next=doc.querySelector('cart-drawer');if(target&&next){target.innerHTML=next.innerHTML;target.classList.toggle('is-empty',next.classList.contains('is-empty'));}}else{const target=document.getElementById('shopify-section-'+id);const next=doc.getElementById('shopify-section-'+id);if(target&&next)target.innerHTML=next.innerHTML;}}
   const status=document.querySelector('bba-page-offers .bba-page-status');if(status)status.textContent=this.dataset.added;
   if(typeof publish==='function')publish(PUB_SUB_EVENTS.cartUpdate,{source:'bba-page-offers'});
  }catch(e){if(error){error.textContent=e.message||this.dataset.error;error.hidden=false;}if(added){window.location.reload();return;}button.disabled=false;button.closest('article')?.classList.remove('is-adding');}finally{this.busy=false;}
 }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bba-collabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('play', event => {
    if (!event.target.matches('.bba-collabs video')) return;
    document.querySelectorAll('.bba-collabs video').forEach(video => {
      if (video !== event.target) video.pause();
    });
  }, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bba-her-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('her-routine')) {
  customElements.define('her-routine', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const form = this.querySelector('form');
      const art = this.querySelector('.her-art__image');
      const pack = this.querySelector('.her-pack img');
      if (art && pack) {
        const original = {src:art.src,srcset:art.getAttribute('srcset')};
        this.querySelectorAll('[data-her-view]').forEach(button => button.addEventListener('click', () => {
          const box = button.dataset.herView === 'box';
          art.removeAttribute('srcset');
          art.src = box ? pack.src : original.src;
          if (!box && original.srcset) art.setAttribute('srcset',original.srcset);
          art.classList.toggle('her-art__image--box',box);
          this.querySelectorAll('[data-her-view]').forEach(item => item.setAttribute('aria-pressed',String(item===button)));
        }));
      }
      this.querySelector('[data-her-variant]')?.addEventListener('change', e => {
        const url = new URL(location.href); url.searchParams.set('variant', e.target.value); location.assign(url);
      });
      form.addEventListener('submit', async e => {
        e.preventDefault();
        if (this.busy || !form.reportValidity()) return;
        this.busy = true;
        const buttons = this.querySelectorAll('[type="submit"]');
        const error = this.querySelector('.her-error');
        buttons.forEach(b => {b.disabled = true;b.setAttribute('aria-busy','true');});
        error.hidden = true;
        try {
          const drawer = document.querySelector('cart-drawer');
          const body = new FormData(form);
          if (drawer) {
            body.append('sections', drawer.getSectionsToRender().map(s=>s.id).join(','));
            body.append('sections_url', location.pathname);
            drawer.setActiveElement(e.submitter || form.querySelector('button'));
          }
          const response = await fetch(window.routes.cart_add_url,{method:'POST',headers:{Accept:'application/json'},body});
          const data = await response.json();
          if (!response.ok || data.status) throw new Error(data.description || this.dataset.error);
          if (drawer) {
            drawer.classList.remove('is-empty');drawer.renderContents(data);
            if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate,{source:'her-routine',cartData:data});
          } else location.assign(window.routes.cart_url);
        } catch (err) { error.textContent = err.message || this.dataset.error;error.hidden = false; }
        finally { this.busy=false;buttons.forEach(b=>{b.disabled=false;b.removeAttribute('aria-busy');}); }
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bba-product-tabs"] && !Shopify.designMode) return;
  try {
    
for (const navigation of document.querySelectorAll('.bba-wardrobe-tabs')) {
  const rail = navigation.querySelector('[role="tablist"]');
  const previous = navigation.querySelector('[data-wardrobe-prev]');
  const next = navigation.querySelector('[data-wardrobe-next]');
  const update = () => {
    previous.disabled = rail.scrollLeft <= 2;
    next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
  };
  const move = direction => rail.scrollBy({left: direction * rail.clientWidth * .8, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
  previous.addEventListener('click', () => move(-1));
  next.addEventListener('click', () => move(1));
  rail.addEventListener('scroll', update, {passive:true});
  rail.addEventListener('keydown', event => {
    if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
    const tabs = [...rail.querySelectorAll('[role="tab"]')];
    const index = tabs.indexOf(document.activeElement);
    if (index < 0) return;
    event.preventDefault();
    const position = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
    tabs[position].click(); tabs[position].focus({preventScroll:true});
    tabs[position].scrollIntoView({block:'nearest',inline:'nearest'});
  });
  if (window.ResizeObserver) new ResizeObserver(update).observe(rail);
  window.addEventListener('resize', update);
  document.fonts?.ready.then(update);
  requestAnimationFrame(update);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bba-product-upsell"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bba-trio')) {
  customElements.define('bba-trio', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.form = this.querySelector('form');
      this.button = this.querySelector('[type="submit"]');
      this.label = this.querySelector('[data-trio-label]');
      this.idleLabel = this.label.textContent;
      this.status = this.querySelector('[role="status"]');
      this.cartLink = this.querySelector('.bba-trio__cart-link');
      this.form.addEventListener('change', () => { this.userInteracted = true; this.updateTotal(); });
      this.form.addEventListener('focusin', () => { this.userInteracted = true; });
      this.form.addEventListener('submit', (event) => this.addTrio(event));
      this.updateTotal();
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({data}) => {
          const main = document.querySelector('product-info[data-product-id="' + this.dataset.productId + '"]');
          if (!main || data.sectionId !== main.dataset.section || !data.variant) return;
          const control = this.querySelector('[data-trio-current] [data-trio-variant]');
          if (control?.tagName === 'SELECT' && [...control.options].some(option => option.value === String(data.variant.id))) {
            control.value = String(data.variant.id);
            this.updateTotal();
          }
        });
      }
      this.loadRecommendations();
    }
    disconnectedCallback() { this.unsubscribe?.(); }
    async loadRecommendations() {
      if (!this.dataset.recommendationsUrl) return;
      try {
        const response = await fetch(this.dataset.recommendationsUrl, {headers:{'Accept':'text/html'}});
        if (!response.ok) return;
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const fresh = html.querySelector('bba-trio[data-product-id="' + this.dataset.productId + '"]');
        const companions = fresh ? [...fresh.querySelectorAll('.bba-trio__item:not([data-trio-current])')] : [];
        if (companions.length !== 2 || this.busy || this.userInteracted || !this.isConnected) return;
        const existing = [...this.querySelectorAll('.bba-trio__item:not([data-trio-current])')];
        existing.forEach(card => card.remove());
        this.querySelector('.bba-trio__products').append(...companions);
        this.querySelector('.bba-trio__panel').hidden = false;
        this.updateTotal();
      } catch (_) {}
    }
    selections() {
      return [...this.querySelectorAll('[data-trio-variant]')].map(control => {
        const source = control.tagName === 'SELECT' ? control.selectedOptions[0] : control;
        return { id: Number(control.value), quantity: 1, cents: Number(source.dataset.cents), compare: Math.max(Number(source.dataset.compare) || 0, Number(source.dataset.cents)), label: source.dataset.price, available: source.dataset.available !== 'false' && !source.disabled, control };
      });
    }
    updateTotal() {
      const selected = this.selections();
      const money = value => new Intl.NumberFormat(this.dataset.locale || 'en', {style:'currency',currency:this.dataset.currency}).format(value / 100);
      selected.forEach(item => {
        const card = item.control.closest('.bba-trio__item');
        card.querySelector('[data-trio-price]').textContent = item.label;
        const compare = card.querySelector('[data-trio-compare]');
        const saving = card.querySelector('[data-trio-saving]');
        if (compare) { compare.hidden = item.compare <= item.cents; compare.textContent = money(item.compare); }
        if (saving) { saving.hidden = item.compare <= item.cents; saving.textContent = '−' + Math.round((item.compare - item.cents) * 100 / (item.compare || 1)) + '%'; }
      });
      this.button.disabled = Boolean(this.busy) || selected.length !== 3 || selected.some(item => !item.available);
      const cents = selected.reduce((sum, item) => sum + item.cents, 0);
      const regular = selected.reduce((sum, item) => sum + item.compare, 0);
      const original = this.querySelector('[data-trio-regular-total]');
      const savings = this.querySelector('[data-trio-total-saving]');
      if (original) { original.hidden = regular <= cents; original.textContent = money(regular); }
      if (savings) { savings.hidden = regular <= cents; this.querySelector('[data-trio-savings-amount]').textContent = money(regular - cents); }
      try { this.querySelector('[data-trio-total]').textContent = new Intl.NumberFormat(this.dataset.locale || 'en', {style:'currency',currency:this.dataset.currency}).format(cents / 100); } catch (_) {}
    }
    async addTrio(event) {
      event.preventDefault();
      if (this.busy) return;
      const selected = this.selections();
      if (selected.length !== 3 || new Set(selected.map(item => item.id)).size !== 3 || selected.some(item => !item.id || !item.available)) return;
      this.busy = true;
      this.button.disabled = true;
      this.setAttribute('aria-busy', 'true');
      this.label.textContent = this.dataset.adding;
      this.querySelector('.bba-trio__spinner').hidden = false;
      this.status.hidden = true;
      this.cartLink.hidden = true;
      const controls = [...this.querySelectorAll('select')];
      controls.forEach(control => control.disabled = true);
      const cart = document.querySelector('cart-drawer');
      let added = false;
      try {
        const payload = {items: selected.map(({id,quantity}) => ({id,quantity}))};
        const sections = cart?.getSectionsToRender?.().map(section => section.id).slice(0,5);
        if (sections?.length) { payload.sections = sections; payload.sections_url = window.location.pathname; }
        cart?.setActiveElement?.(this.button);
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(root + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)});
        const data = await response.json();
        if (!response.ok || data.status) {
          const error = new Error(typeof data.description === 'string' ? data.description : this.dataset.error);
          error.confirmed = true;
          throw error;
        }
        added = true;
        this.status.textContent = this.dataset.success;
        this.status.dataset.error = 'false';
        this.status.hidden = false;
        this.cartLink.hidden = false;
        if (cart && sections.every(id => typeof data.sections?.[id] === 'string')) {
          cart.classList.remove('is-empty');
          cart.renderContents(data);
        } else { window.location.assign(root + 'cart'); }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          Promise.resolve(publish(PUB_SUB_EVENTS.cartUpdate, {source:'bba-trio',cartData:data})).catch(() => {});
        }
      } catch (error) {
        this.status.textContent = added ? this.dataset.success : (error.confirmed ? error.message : this.dataset.error);
        this.status.dataset.error = added ? 'false' : 'true';
        this.status.hidden = false;
        this.cartLink.hidden = false;
      } finally {
        this.busy = false;
        this.button.disabled = false;
        this.removeAttribute('aria-busy');
        this.label.textContent = this.idleLabel;
        this.querySelector('.bba-trio__spinner').hidden = true;
        controls.forEach(control => control.disabled = false);
        this.updateTotal();
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bba-skin-main"]) return;
  try {
    
  if (!customElements.get('bba-skin-quantity-offer')) {
    customElements.define('bba-skin-quantity-offer', class BbaQuantityOffer extends HTMLElement {
      connectedCallback() {
        this.hiddenInput = this.querySelector('[data-bba-quantity-offer-input]');
        this.productInfo = this.closest('product-info');
        this.quantityInput = this.productInfo?.querySelector('.quantity__input');
        if (this.quantityInput && this.hiddenInput) this.hiddenInput.disabled = true;
        this.querySelectorAll('[data-quantity]').forEach((card) => card.addEventListener('click', () => this.select(card)));
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (data.sectionId !== this.productInfo?.dataset.section) return;
          const next = data.html.querySelector('bba-skin-quantity-offer');
          if (!next) return;
          this.querySelectorAll('[data-pack-price]').forEach((price) => {
            const replacement = next.querySelector(`[data-pack-price="${price.dataset.packPrice}"]`);
            if (replacement) price.innerHTML = replacement.innerHTML;
          });
        });
      }

      disconnectedCallback() { this.unsubscribe?.(); }

      select(card) {
        const quantity = Number(card.dataset.quantity || 1);
        this.querySelectorAll('[data-quantity]').forEach((item) => {
          const selected = item === card;
          item.classList.toggle('is-selected', selected);
          item.setAttribute('aria-checked', selected ? 'true' : 'false');
        });
        const input = this.quantityInput || this.hiddenInput;
        if (!input) return;
        input.value = quantity;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  if (!customElements.get('bba-sticky-product-buy')) {
    customElements.define('bba-sticky-product-buy', class BbaStickyProductBuy extends HTMLElement {
      connectedCallback() {
        this.productInfo = this.closest('product-info');
        this.action = this.querySelector('[data-bba-sticky-submit]');
        this.price = this.querySelector('[data-bba-sticky-price]');
        this.action?.addEventListener('click', () => this.originalButton?.click());
        this.mutationObserver = new MutationObserver(() => this.refresh());
        if (this.productInfo) this.mutationObserver.observe(this.productInfo, { childList: true, subtree: true, attributes: true });
        this.intersectionObserver = new IntersectionObserver((entries) => {
          this.classList.toggle('is-visible', !entries[0]?.isIntersecting);
        }, { threshold: .2 });
        this.refresh();
      }

      refresh() {
        const nextButton = this.productInfo?.querySelector('.product-form__submit');
        if (nextButton && nextButton !== this.originalButton) {
          this.intersectionObserver.disconnect();
          this.originalButton = nextButton;
          this.intersectionObserver.observe(nextButton);
        }
        if (!this.originalButton || !this.action) return;
        const disabled = this.originalButton.disabled || this.originalButton.getAttribute('aria-disabled') === 'true';
        if (this.action.disabled !== disabled) this.action.disabled = disabled;
        const label = this.originalButton.querySelector('span:not(.sold-out-message)');
        if (label?.textContent.trim() && this.action.textContent.trim() !== label.textContent.trim()) this.action.textContent = label.textContent.trim();
        const price = this.productInfo?.querySelector('.price__sale .price-item--sale, .price__regular .price-item--regular');
        if (price?.textContent.trim() && this.price?.textContent.trim() !== price.textContent.trim()) this.price.textContent = price.textContent.trim();
      }

      disconnectedCallback() {
        this.mutationObserver?.disconnect();
        this.intersectionObserver?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (!customElements.get('bba-quantity-offer')) {
    customElements.define('bba-quantity-offer', class BbaQuantityOffer extends HTMLElement {
      connectedCallback() {
        this.hiddenInput = this.querySelector('[data-bba-quantity-offer-input]');
        this.productInfo = this.closest('product-info');
        this.quantityInput = this.productInfo?.querySelector('.quantity__input');
        if (this.quantityInput && this.hiddenInput) this.hiddenInput.disabled = true;
        this.querySelectorAll('[data-quantity]').forEach((card) => card.addEventListener('click', () => this.select(card)));
      }

      select(card) {
        const quantity = Number(card.dataset.quantity || 1);
        this.querySelectorAll('[data-quantity]').forEach((item) => {
          const selected = item === card;
          item.classList.toggle('is-selected', selected);
          item.setAttribute('aria-checked', selected ? 'true' : 'false');
        });
        const input = this.quantityInput || this.hiddenInput;
        if (!input) return;
        input.value = quantity;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  if (!customElements.get('bba-sticky-product-buy')) {
    customElements.define('bba-sticky-product-buy', class BbaStickyProductBuy extends HTMLElement {
      connectedCallback() {
        this.productInfo = this.closest('product-info');
        this.action = this.querySelector('[data-bba-sticky-submit]');
        this.price = this.querySelector('[data-bba-sticky-price]');
        this.action?.addEventListener('click', () => this.originalButton?.click());
        this.mutationObserver = new MutationObserver(() => this.refresh());
        if (this.productInfo) this.mutationObserver.observe(this.productInfo, { childList: true, subtree: true, attributes: true });
        this.intersectionObserver = new IntersectionObserver((entries) => {
          this.classList.toggle('is-visible', !entries[0]?.isIntersecting);
        }, { threshold: .2 });
        this.refresh();
      }

      refresh() {
        const nextButton = this.productInfo?.querySelector('.product-form__submit');
        if (nextButton && nextButton !== this.originalButton) {
          this.intersectionObserver.disconnect();
          this.originalButton = nextButton;
          this.intersectionObserver.observe(nextButton);
        }
        if (!this.originalButton || !this.action) return;
        const disabled = this.originalButton.disabled || this.originalButton.getAttribute('aria-disabled') === 'true';
        if (this.action.disabled !== disabled) this.action.disabled = disabled;
        const label = this.originalButton.querySelector('span:not(.sold-out-message)');
        if (label?.textContent.trim() && this.action.textContent.trim() !== label.textContent.trim()) this.action.textContent = label.textContent.trim();
        const price = this.productInfo?.querySelector('.price__sale .price-item--sale, .price__regular .price-item--regular');
        if (price?.textContent.trim() && this.price?.textContent.trim() !== price.textContent.trim()) this.price.textContent = price.textContent.trim();
      }

      disconnectedCallback() {
        this.mutationObserver?.disconnect();
        this.intersectionObserver?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["radiant-buy-the-look"] && !Shopify.designMode) return;
  try {
    
function radiantBuyLookInit(root){if(root.dataset.ready)return;root.dataset.ready='true';var rows=[].slice.call(root.querySelectorAll('[data-rbtl-row]'));var money=function(cents){try{return new Intl.NumberFormat(undefined,{style:'currency',currency:root.dataset.currency,maximumFractionDigits:0}).format(Number(cents)/100)}catch(e){return (Number(cents)/100).toFixed(0)}};var update=function(){var total=0;rows.forEach(function(row){var check=row.querySelector('[data-rbtl-check]'),option=row.querySelector('[data-rbtl-variant]').selectedOptions[0];if(check.checked&&option)total+=Number(option.dataset.price)});root.querySelector('[data-rbtl-total]').textContent=money(total)};var focus=function(id){root.querySelectorAll('.is-active').forEach(function(el){el.classList.remove('is-active')});var card=root.querySelector('[data-rbtl-id="'+id+'"]'),spot=root.querySelector('[data-rbtl-target="'+id+'"]');if(card)card.classList.add('is-active');if(spot)spot.classList.add('is-active');if(window.innerWidth<990&&card)card.scrollIntoView({behavior:'smooth',block:'center'})};root.addEventListener('click',function(e){var trigger=e.target.closest('[data-rbtl-target],[data-rbtl-focus]');if(trigger){focus(trigger.dataset.rbtlTarget||trigger.dataset.rbtlFocus)}});root.addEventListener('change',update);root.querySelector('[data-rbtl-add]').addEventListener('click',function(){var button=this,items=[];rows.forEach(function(row){if(row.querySelector('[data-rbtl-check]').checked)items.push({id:Number(row.querySelector('[data-rbtl-variant]').value),quantity:1})});if(!items.length)return;button.disabled=true;root.querySelector('[data-rbtl-message]').textContent='';fetch(root.dataset.cartUrl+'.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})}).then(function(response){if(!response.ok)throw new Error();return response.json()}).then(function(){root.querySelector('[data-rbtl-message]').textContent=root.dataset.success;document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}))}).catch(function(){root.querySelector('[data-rbtl-message]').textContent=root.dataset.error}).finally(function(){button.disabled=false})});update();if(rows[0])focus(rows[0].dataset.rbtlId)}document.querySelectorAll('[data-rbtl]').forEach(radiantBuyLookInit);document.addEventListener('shopify:section:load',function(e){var root=e.target.querySelector('[data-rbtl]');if(root)radiantBuyLookInit(root)});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["radiant-foundation-page"] && !Shopify.designMode) return;
  try {
    
function radiantSetGallery(section,variantId){var sets=[].slice.call(section.querySelectorAll('[data-gallery-set]'));sets.forEach(function(set){var active=set.dataset.gallerySet===String(variantId);set.hidden=!active;set.classList.toggle('is-active',active);if(active){var thumbs=[].slice.call(set.querySelectorAll('[data-gallery-thumb]'));thumbs.forEach(function(thumb,index){thumb.classList.toggle('is-active',index===0);thumb.setAttribute('aria-current',index===0?'true':'false')});var main=set.querySelector('.rf__main-image');if(main&&thumbs[0]){main.src=thumbs[0].dataset.image;main.removeAttribute('srcset')}}})}
function radiantChooseThumb(set,thumb){var main=set.querySelector('.rf__main-image');if(!main)return;set.querySelectorAll('[data-gallery-thumb]').forEach(function(item){var active=item===thumb;item.classList.toggle('is-active',active);item.setAttribute('aria-current',active?'true':'false')});main.style.opacity='.35';var nextImage=new Image();nextImage.onload=function(){main.src=thumb.dataset.image;main.removeAttribute('srcset');main.style.opacity='1'};nextImage.onerror=function(){main.style.opacity='1'};nextImage.src=thumb.dataset.image}
document.addEventListener('change',function(event){if(!event.target.matches('[data-radiant-section] input[name="radiant-variant"]'))return;var section=event.target.closest('[data-radiant-section]');var input=event.target;var hidden=section.querySelector('[data-radiant-variant-id]');var shade=section.querySelector('[data-radiant-shade]');var status=section.querySelector('[data-radiant-status]');var submit=section.querySelector('[data-radiant-submit]');var submitLabel=section.querySelector('[data-radiant-submit-label]');var submitPrice=section.querySelector('[data-radiant-submit-price]');var price=section.querySelector('[data-radiant-price]');var available=input.dataset.available==='true';radiantSetGallery(section,input.value);if(hidden)hidden.value=input.value;if(shade)shade.textContent=input.dataset.title;if(status)status.textContent=available?section.dataset.availableLabel:section.dataset.unavailableLabel;if(submit)submit.disabled=!available;if(submitLabel)submitLabel.textContent=available?section.dataset.addLabel:section.dataset.unavailableLabel;if(submitPrice)submitPrice.textContent=input.dataset.price;if(price)price.innerHTML='<strong>'+input.dataset.price+'</strong>'+(input.dataset.comparePrice?'<s>'+input.dataset.comparePrice+'</s>':'')});
document.addEventListener('click',function(event){var guide=event.target.closest('[data-guide-variant]');if(guide){var guideSection=guide.closest('[data-radiant-section]');var input=guideSection.querySelector('input[name="radiant-variant"][value="'+guide.dataset.guideVariant+'"]');if(input){input.checked=true;input.dispatchEvent(new Event('change',{bubbles:true}));guideSection.scrollIntoView({behavior:'smooth'})}return}var thumb=event.target.closest('[data-gallery-thumb]');if(thumb){radiantChooseThumb(thumb.closest('[data-gallery-set]'),thumb);return}var arrow=event.target.closest('[data-gallery-prev],[data-gallery-next]');if(!arrow)return;var set=arrow.closest('[data-gallery-set]');var thumbs=[].slice.call(set.querySelectorAll('[data-gallery-thumb]'));var current=thumbs.findIndex(function(item){return item.classList.contains('is-active')});var direction=arrow.hasAttribute('data-gallery-next')?1:-1;var next=(current+direction+thumbs.length)%thumbs.length;radiantChooseThumb(set,thumbs[next])});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["radiant-frequently-bought"] && !Shopify.designMode) return;
  try {
    
function radiantBundleInit(root){if(root.dataset.ready)return;root.dataset.ready='true';var money=function(cents){try{return new Intl.NumberFormat(undefined,{style:'currency',currency:root.dataset.currency,maximumFractionDigits:0}).format(Number(cents)/100)}catch(error){return (Number(cents)/100).toFixed(0)}};var rows=function(){return Array.prototype.slice.call(root.querySelectorAll('.rfbt__choice'))};var update=function(){var total=0;rows().forEach(function(row){var checked=row.querySelector('[data-rfbt-check]').checked;var option=row.querySelector('[data-rfbt-variant]').selectedOptions[0];if(checked&&option)total+=Number(option.dataset.price)});root.querySelector('[data-rfbt-total]').textContent=money(total)};root.addEventListener('change',update);root.querySelector('[data-rfbt-add]').addEventListener('click',function(){var button=this;var items=[];rows().forEach(function(row){if(row.querySelector('[data-rfbt-check]').checked){items.push({id:Number(row.querySelector('[data-rfbt-variant]').value),quantity:1})}});if(!items.length)return;button.disabled=true;root.querySelector('[data-rfbt-message]').textContent='';fetch(root.dataset.cartUrl+'.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})}).then(function(response){if(!response.ok)throw new Error();return response.json()}).then(function(){root.querySelector('[data-rfbt-message]').textContent=root.dataset.success;document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}))}).catch(function(){root.querySelector('[data-rfbt-message]').textContent=root.dataset.error}).finally(function(){button.disabled=false})});update()}document.querySelectorAll('[data-rfbt]').forEach(radiantBundleInit);document.addEventListener('shopify:section:load',function(event){var root=event.target.querySelector('[data-rfbt]');if(root)radiantBundleInit(root)});

  } catch(e) { console.error(e); }
})();
})();
